import { Download } from '@mui/icons-material';
import { IconButton, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC } from 'react';
import { getUserJwt } from '../../../../../context/AuthHelper';
import { STRAPI_URL } from '../../../../../lib/constants/url';
import { GetFileSize } from '../../../../../utils/formats';
import { enumT } from '../../../../../utils/helper';

interface DownloadFileFromComponentProps {
	component: any;
	filePathInComponent: string;
	showDownloadButton?: boolean;
	showInTable?: boolean;
}

const DownloadFileFromComponent: FC<DownloadFileFromComponentProps> = ({ component, filePathInComponent, showDownloadButton = true, showInTable }) => {
	const handleDownload = async (url: string, fileName: string) => {
		try {
			let res = await fetch(`${STRAPI_URL}${url}`, {
				headers: {
					Authorization: `Bearer ${getUserJwt()}`,
				},
			});

			const blob = await res.blob();
			const objectUrl = URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = objectUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			link.remove();
			URL.revokeObjectURL(objectUrl);
		} catch (err: any) {
			console.error('ERROR: downloading File ', err);
		}
	};
	if (isArray(component) && component.length > 0 && showInTable) {
		return (
			<>
				<TableContainer sx={{ overflow: 'initial', mt: '1rem' }}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Titel</TableCell>
								<TableCell>Dateiart</TableCell>
								<TableCell align="right">Dateigröße</TableCell>
								<TableCell align="right">Aktion</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{component.map((ele: any, i: number) => {
								const fileMetaData = get(ele, filePathInComponent, {});
								return (
									<TableRow key={i}>
										<TableCell>{get(ele, 'Titel')}</TableCell>
										<TableCell>{enumT(get(ele, 'Dateiart'))}</TableCell>
										<TableCell align="right">
											{GetFileSize(get(fileMetaData, 'attributes.size') / (get(fileMetaData, 'id') ? 1 : 1000))}
										</TableCell>
										<TableCell align="right">
											{showDownloadButton && get(fileMetaData, 'attributes.url', '') && (
												<IconButton
													onClick={() => handleDownload(get(fileMetaData, 'attributes.url', ''), get(fileMetaData, 'attributes.name'))}>
													<Download />
												</IconButton>
											)}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</>
		);
	} else if (isArray(component) && component.length > 0 && !showInTable) {
		return (
			<>
				{component.map((ele: any,) => {
					return (
						<div key={ele.id}>
							<TableContainer sx={{ overflow: 'initial', ml: '0rem' }}>

								<Table>
									<TableBody>
										<TableRow>

											<TableCell align='left' sx={{ padding: 0, width: '40px'  }}>
												<IconButton
													onClick={() => handleDownload(ele.attributes.url, ele.attributes.name)}>
													<Download />
												</IconButton>
											</TableCell>
											<TableCell sx={{ padding: 0 }} align='left'>
												<Link
													color="text.primary"
													style={{ cursor: 'pointer' }}
													onClick={() => handleDownload(ele.attributes.url, ele.attributes.name)}>
													{ele.attributes.name}
												</Link>
											</TableCell>
										</TableRow>

									</TableBody>
								</Table>
							</TableContainer>
						</div>


					);
				})}
			</>
		);
	}
	return <></>;
};
export default DownloadFileFromComponent;
